import CryptoJS from "crypto-js";

export const useLogOut = () => {
  return () => {
    const clearAndRedirect = (path) => {
      localStorage.removeItem(`${path}_token`);
      window.location.href = `/${path}/auth/login`;
    };

    const pathPrefix =
      location.pathname.match(/(admin|client)\//)?.[0] || "admin";
    const newPath = pathPrefix?.replace("/", "");

    if (pathPrefix) {
      clearAndRedirect(newPath);
    } else {
      clearAndRedirect("admin");
    }
  };
};

export const getAssetType = ({ name }) => {
  const extension = name?.split(".")?.pop()?.toLowerCase();

  return extension;
};

export const formatDate = (date, fallback = "") => {
  if (!date) return fallback;

  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export function formatTAT(isoString) {
  const date = new Date(isoString);
  return date.toTimeString().split(" ")[0];
}

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = (error) => reject(error);
  });
};

export const getNumber = (str) => {
  const arr = str.split("");
  const out = [];
  let hasDecimal = false;

  for (let i = 0; i < arr.length; i++) {
    if (!isNaN(arr[i]) || (arr[i] === "." && !hasDecimal)) {
      if (arr[i] === ".") {
        hasDecimal = true;
      }
      out.push(arr[i]);
    }
  }

  return out.join("");
};

export const formatNumberWithCommas = (numStr) => {
  const [integerPart, decimalPart] = numStr.split(".");
  const formattedInteger = parseInt(integerPart).toLocaleString();

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
};

export const formatCreationDate = (timestamp) => {
  if (!timestamp) return null;
  const date = new Date(timestamp);
  return date.toISOString();
};

export const formatDateTime = (date, fallback) => {
  if (!date) return fallback;

  const parsedDate = new Date(date);

  const datePart = parsedDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC", // ✅ force UTC
  });

  const timePart = parsedDate.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  return `${datePart} at ${timePart}`;
};

export const formatTime = (dateString) => {
  return new Date(dateString).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "Africa/Lagos",
  });
};

import { useState } from "react";

const useStaffSearch = (initialValue = "") => {
  const [searchText, setSearchText] = useState(initialValue);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };

  return { searchText, handleSearchChange };
};

export default useStaffSearch;

const cryptoKey = process.env.REACT_APP_CRYPTO_API_KEY;

export const dataEncrypt = (message) => {
  if (typeof message !== "string") return false;
  return CryptoJS.AES.encrypt(message, cryptoKey).toString();
};

export const dataDecrypt = (message) => {
  if (typeof message !== "string") return false;
  const byte = CryptoJS.AES.decrypt(message, cryptoKey);
  return byte?.toString(CryptoJS.enc.Utf8);
};

export const trim = (str) => {
  return str?.length > 10 ? str.substring(0, 10) + "..." : str;
};

export const formatDates = (date, fallback = "") => {
  if (!date) return fallback;

  const formattedDate = new Date(date);

  const year = formattedDate.getFullYear();
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
  const day = formattedDate.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};
